module.exports = __webpack_public_path__ + "img/T1C_xs_001.e21fc61b.png";